const SET_VIRTUAL_NUMBERS_DATA = 'set-virtual-numbers-data';
const SET_VIRTUAL_NUMBERS_FETCH_STATUS = 'set-virtual-numbers-fetch-status';

export default {
  SET_VIRTUAL_NUMBERS_DATA,
  SET_VIRTUAL_NUMBERS_FETCH_STATUS,
};
